"use client";

export default function ErrorPage({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="error-shell">
      <section className="error-card" aria-labelledby="error-title">
        <p className="eyebrow">Laboratório isolado</p>
        <h1 id="error-title">A simulação encontrou um problema.</h1>
        <p>Nenhuma ação externa foi executada. Você pode reiniciar esta tela com segurança.</p>
        <button className="button button-primary" type="button" onClick={reset}>
          Tentar novamente
        </button>
      </section>
    </main>
  );
}
